<div class="row dimming-container">
  <div id="DimmingInterface-interface-text" class="col-1 signifyBookmd interface-text">Interface</div>
  <div class="col-4">
    <select [(ngModel)]="ngModelval['SelectedInterface']" id="DimmingInterface-dropdown" class="signifyBookmd select-dimming"
      (change)="onChangeList($event.target.value)">
      @for (interfaceList of selectedInterface; track interfaceList) {
        <option [value]="interfaceList" class="info-val">
          {{ interfaceList }}
        </option>
      }
    </select>
  </div>
  <div class="col-7"></div>
</div>
@if (showOverride || showCodedMains) {
  <div class="row dimming-container">
    <div class="col-1 signifyBookmd interface-text"></div>
    <div class="col-4"><span class="signifyBookmd"><strong>Can be overridden by</strong></span></div>
  </div>
}
@if (showOverride) {
  <div class="row dimming-container">
    <div class="col-1 signifyBookmd interface-text"></div>
    <div class="col-4">
      <input type="checkbox" class="primary-checkbox" id="ForLineSwitch"
        (change)="toggleValue($event.target.checked,'LineSwitch')" [(ngModel)]="isLineSwitchOverride"
        [checked]="isLineSwitchOverride"/>
        <label for="ForLineSwitch"><span id="DimmingInterface-overridden-lineswitch" class="signifyBookmd extra-border-enablefeat"></span></label>
        <span  class="signifyBookmd">LineSwitch</span>
      </div>
    </div>
  }
  <!-- ///MOWEB 1.1 Changes -->
  @if (showCodedMains) {
    <div class="row dimming-container">
      <div class="col-1 signifyBookmd interface-text"></div>
      <div class="col-4">
        <input type="checkbox" class="primary-checkbox" id="ForCodedMains"
          (change)="toggleValue($event.target.checked,'CodedMains')" [(ngModel)]="isCodedMainsOverride"
          [checked]="isCodedMainsOverride"/>
          <label for="ForCodedMains" aria-label="CodedMains override"><span id="DimmingInterface-overridden-codedmains" class="signifyBookmd extra-border-enablefeat"></span></label>
          <span class="signifyBookmd">CodedMains</span>
        </div>
      </div>
    }
    @if (openDynaDimmer) {
      <div class="row dimming-container">
        <div class="col-1 signifyBookmd">Override Selections:</div>
        <div class="col-4">
          @for (showOverList of OverridenList; track showOverList) {
            <div class="row">
              <div class="col-8">
                <span class="signifyBookmd">{{showOverList}}</span>
                <input type="checkbox" class="primary-checkbox" id="{{showOverList}}"
                  (change)="paramterChecked($event.target.checked, showOverList)" />
                  <label class="setting-checkbox" for="{{showOverList}}" [attr.aria-label]="showOverList"><span></span></label>
                </div>
              </div>
            }
          </div>
        </div>
      }
